import React, { memo } from 'react'
import { FormProvider, useFormContext } from 'react-hook-form'
import { IUseSavedLaneFormProps, useSavedLaneForm } from '../hooks/useSavedLaneForm'
import { TSavedLaneSchema } from '../schema'

export interface ISavedLaneFormProviderProps extends IUseSavedLaneFormProps {
  children: React.ReactNode
}

const SavedLaneFormProvider = memo<ISavedLaneFormProviderProps>(
  ({ children, context, defaultValues = {}, ...props }) => {
    const methods = useSavedLaneForm({
      context,
      defaultValues,
      ...props,
    })

    return <FormProvider {...methods}>{children}</FormProvider>
  }
)

export default SavedLaneFormProvider

export const useSavedLaneFormContext = () => useFormContext<TSavedLaneSchema>()
